module.exports = __webpack_public_path__ + "static/img/share_case.2ba74a7a.jpg";